/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ConnectProjectsEntrypointComponent = EntryPointComponent<
	{},
	{},
	{},
	{
		query: RouteContext['query'];
		match?: RouteContext['match'];
		hash?: string;
	}
>;

export const connectProjectsEntrypoint: EntryPoint<
	ConnectProjectsEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<ConnectProjectsEntrypointComponent>(
		/* webpackChunkName: "async-connect-projects-entrypoint" */ './index.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		extraProps: {
			query: context.query,
			match: context.match,
			hash: globalThis?.location?.hash || '',
		},
	}),
});
